/* eslint-disable */
import { FORM_NAME } from './calculate-payroll-data-constants';

export const formSelector = (state) => ({
  fields: state.form?.[FORM_NAME]?.fields,
  syncErrors: state.form?.[FORM_NAME]?.syncErrors,
  registeredFields: state.form?.[FORM_NAME]?.registeredFields,
});